import { FC, memo } from "react";
import { AppShell } from "@mantine/core";
import { motion, AnimatePresence } from "framer-motion";
import { footerVariants } from "./Animations";
import { NavLinks } from "./Components";

import styles from "./Footer.module.scss";

const FooterComponent: FC = () => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="footer"
        variants={footerVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        className={styles.footer}
      >
        <AppShell.Footer className={styles.footerContent}>
          <NavLinks />
        </AppShell.Footer>
      </motion.div>
    </AnimatePresence>
  );
};

export const Footer = memo(FooterComponent, () => true);
